import * as React from 'react';
import { useSelector } from 'react-redux';

import { CardSectionNew } from 'shared/components/CardSectionNew';
import { EBannerType } from 'shared/constants/banner';
import { NewbuildingSuburbanBannerContainer } from 'shared/containers/NewbuildingSuburbanBannerContainer';
import { selectBannerRotation } from 'shared/selectors/selectBannerRotation';

import { trackSubscribed, trackSubscriptionModalClose, trackSubscriptionModalOpen } from './tracking';
import { useSearchSetParams } from './useSearchSetParams';
import { SaveSearchContainer, TOnSubmitSaveSearchParams, useSaveSearchEvents } from '../../../packages/SaveSearchModal';
import { LocationSubscription } from '../../components/LocationSubscription';

export const LocationSubscriptionContainer = () => {
  const bannerRotation = useSelector(selectBannerRotation);
  const { handleClick, offerId } = useSearchSetParams();

  const handleOnSubscribed = React.useCallback(
    (parameters: TOnSubmitSaveSearchParams) => {
      trackSubscribed({
        frequency: parameters.frequency,
        subscribeToNews: parameters.subscribeToNews,
        title: parameters.title,
        email: parameters.email,
        defaultTitle: parameters.defaultTitle,
        defaultEmail: parameters.defaultEmail,
        offerId,
      });

      /* istanbul ignore next */
      if (window.__reloadHeader__) {
        window.__reloadHeader__();
      }
    },
    [offerId],
  );

  useSaveSearchEvents(handleOnSubscribed, trackSubscriptionModalOpen, trackSubscriptionModalClose);

  switch (bannerRotation) {
    case EBannerType.SuburbanListing:
    case EBannerType.SuburbanKpnCallback:
      return (
        <CardSectionNew hideForPrint overflowHidden>
          <NewbuildingSuburbanBannerContainer bannerType={bannerRotation} />
        </CardSectionNew>
      );

    default:
      return (
        <CardSectionNew hideForPrint withBorders>
          <LocationSubscription onClick={handleClick} />
          <SaveSearchContainer />
        </CardSectionNew>
      );
  }

  return null;
};
